angular.module('account', [
    'app',
    'mychart',

    //third party
    'angularLocalStorage',
    'gettext',
    'lodash',
    'ngAnimate',
    'ngTouch',
    'restangular',
    'toaster',
    'ui.bootstrap',
    'ui.router',


    //aprima
    'apEasyScroller',

    'aprima-core',
    'aprima-bridge',
    'aprima-config',
    'aprima-legacy-common',
    'aprima-provider-api',
    'aprima-patient-api',
    'aprima-utils'
]);

